import React from 'react'
import { Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import Cookies from 'universal-cookie'
import { links, loggedInLinks } from '../../../data'
import './styles.scss'

const Footer = () => {
    const cookie = new Cookies();

    return (
        <div className='footerWrapper'>
            <Container className='footerBootstrapContainer'>
                <div className='footerContainer'>
                    <div className='footerSocialMediaContainer'>
                        <h4>Social Media</h4>
                    </div>
                    <div className='footerLinksContainer'>
                        <div className='footerBody'>
                            {
                                links.map(link => (
                                    <Link to={link.path} className='footerLink'>
                                        <p>{link.link}</p>
                                    </Link>
                                ))
                            }
                            {
                                cookie.get('token') && loggedInLinks.map(link => (
                                    <Link to={link.path} className='footerLink'>
                                        <p>{link.link}</p>
                                    </Link>
                                ))
                            }
                        </div>

                    </div>

                </div>
            </Container>
            <div className='copyrightContainer'>
                <p>Copyright 2023 Crypto Recovery – All rights reserved</p>
            </div>
        </div>
    )
}

export default Footer